import React from 'react';

function Cell() {
    return (
        <span className='cell'/>
    );
}

export default Cell;